import { Component, ElementRef, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { EvalDealerPersonalizationConfigUtils } from "@app/views/public/eval-dealer-personalization-model";
import { PluginRaioXTermsComponent } from "./plugin-raio-x-terms.component";
import { PluginRaioXService } from "@app/views/public/plugin-raio-x/plugin-raio-x.service";

@Component({
  selector: "app-plugin-raio-x-layout",
  templateUrl: "./plugin-raio-x-layout.component.html",
  styleUrls: ["./plugin-raio-x-layout.component.scss"],
})
export class PluginRaioXLayoutComponent implements OnInit {

  currentYear: number;
  showTermsConditionsModal: boolean;

  constructor(private dialog: MatDialog, private elRef: ElementRef, private service: PluginRaioXService) { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();

    this.service.primaryColor$.subscribe(resp => {this.setPrimaryColor(resp)});
  }

  openTermsConditionsModal(): void {
    this.dialog
      .open(PluginRaioXTermsComponent, {
        width: '480px',
        hasBackdrop: true,
      })
      .afterClosed()
      .subscribe(({ success, comments }) => {

      });
  }

  setPrimaryColor(color: string): void {
    EvalDealerPersonalizationConfigUtils.setCssVar(this.elRef, '--layout-bg-color', color);
  }

}
